import * as DTO from './DTOs';
import * as API from './apisvc';
import * as TF from '../service/tradeflow';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const OTC_USERSTATE = '_otc.user';


export interface IdentityState {
    isAuthenticated: boolean;
    isTrader: boolean;
    isDepoTrader: boolean;
    isRepoTrader: boolean;
    isNotesTrader: boolean;
    isAdmin: boolean;
    userName: string;
    identAction?: 'changepassword' | 'logout' | 'refresh' | undefined;
    authTokenState?: AuthTokenState;
    concurrencyStamp: string;
}


export interface AuthTokenState {
    loginProvider: string;
    expiration: string;
    token: string;
}

export interface PersonalState {
    idperson: number;
    firstName: string;
    lastName: string;
    sureName: string;
    sortName: string;
    email: string;
    phoneNumber: string;
    contactInfo: string;
    entity?: DTO.EntityDto;
}


export const AnonimousIdentityState: IdentityState = {
    isAdmin: false,
    isAuthenticated: false,
    isTrader: false,
    isDepoTrader: false,
    isRepoTrader: false,
    isNotesTrader: false,
    userName: '',
    authTokenState: undefined,
    concurrencyStamp: ''
}

export interface UserState {
    identityState: IdentityState;
    personalState?: PersonalState;
}

export interface LoginState {
    loggedin: boolean;
    //userId?: string;
    loginError?: string;
    userName?: string;
    cred: Credentials;
    //imageUrl?: string;
}

export interface ChangePasswordState {

    changed: boolean;
    pmod: PassModification;
    changePassError?: string | string[] | any[];
}


//export class LoginModel {
//    email: string;
//    password: string;
//    rememberLogin?: boolean;
//    returnUrl?: string;
//    isLockedOut?: boolean;
//    requiresTwoFactor?: boolean;
//    isNotAllowed?: boolean;
//}

export interface PassModification {
    //userName?: string;
    oldpassword?: string;
    password?: string;
    passwordConfirm?: string;
    returnUrl?: string;
}

export interface Credentials {
    userName: string;
    password: string;
    rememberLogin?: boolean;
    returnUrl?: string;
    islockedout: boolean;
}


export function currentUser() {
    var userdata = sessionStorage.getItem(OTC_USERSTATE);
    if (userdata) {
        let user: UserState = JSON.parse(userdata);
        return user;
    }

    return undefined;
}

export function logoffUser() {
    sessionStorage.removeItem(OTC_USERSTATE);
}

function setCurrentUser(user: UserState) {
    sessionStorage.setItem(OTC_USERSTATE, JSON.stringify(user));
}

export function isloggedIn() {
    var user = currentUser();
    if (user)
        return true;
    else
        return false;
}

export function isActiveTrader() {
    var user = currentUser();
    if (!user)
        return false;
    else
        return user.identityState.isRepoTrader;
}


interface StartLoginAction { type: 'START_LOGIN' }
interface LoginSuccessAction { type: 'LOGIN_SUCCESS', payload: { user: UserState } }
interface LoginFailedAction { type: 'LOGIN_FAILED', payload: { error: string | string[] } }
interface StartLogoutAction { type: 'START_LOGOUT' }
interface LogoutSuccessAction { type: 'LOGOUT_SUCCESS' }
interface LogoutFailedAction { type: 'LOGOUT_FAILED' }
interface StartChPassAction { type: 'START_CHPASS' }
interface ChPassSuccessAction { type: 'CHPASS_SUCCESS', payload: { user: UserState } }
interface ChPassFailedAction { type: 'CHPASS_FAILED', payload: { error: string | string[] } }


export type LoginAction = | StartLoginAction | LoginSuccessAction | LoginFailedAction | StartLogoutAction | LogoutSuccessAction | LogoutFailedAction | StartChPassAction | ChPassSuccessAction | ChPassFailedAction;

export const loginStateForwarder = (state: LoginState, action: LoginAction) => {
    switch (action.type) {
        case 'START_LOGIN':
            return { loggedin: false };
        case 'LOGIN_SUCCESS':
            //TF.PublishCommand('COMMAND.changeuser', state);
            return { loggedin: true };
        case 'LOGIN_FAILED':
            return { ...state, loggedin: false, loginError: action.payload.error };
        case 'START_LOGOUT':
            return { loggedin: true };
        case 'LOGOUT_SUCCESS':
            return { loggedin: false };
        case 'LOGOUT_FAILED':
            return { loggedin: true };
        case 'START_CHPASS':
            return { changed: false };
        case 'CHPASS_SUCCESS':
            return { changed: true };
        case 'CHPASS_FAILED':
            return { ...state, changed: false, changePassError: action.payload.error };

        default:
            const exhaustiveCheck: never = action;
    }

    return state || { loggedin: false };
};

export const accountActions = {
    login: (loginInput: Credentials, getState: any, dispatch: (action: LoginAction) => {}) => {

        return (async () => {
            dispatch({ type: 'START_LOGIN' });

            try {
                //const xsrf = getState().xsrf.token;
                const xsrf = getState().xsrfToken ? getState().xsrfToken : '';
                //console.log('url=' + API.apiUrl(API.API_LOGIN_URL));
                //console.log('post=' + JSON.stringify(loginInput));
                const response: Response = await fetch(API.apiUrl(API.API_LOGIN_URL), {
                    method: 'POST',
                    credentials: 'include',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': xsrf
                    }),
                    body: JSON.stringify(loginInput)
                });

                const statusCode = response.status;
                //console.log('statusCode = ' + statusCode);

                if (response.ok) {
                    const resp_data = await response.json();
                    //console.log(resp_data);
                    const data = resp_data as DTO.MessageDto<UserState>;
                    //dispatch(XsrfActionCreators.refresh());
                    // Get updated menu; we may get extra options based on our role
                    // dispatch(NavMenuActionCreators.fetchMenu());
                    // will redirect

                    if (data && data.result) {
                        let user = data.result;
                        if (user && user.identityState.authTokenState && user.identityState.authTokenState.token) {
                            // store user details and jwt token in local storage to keep user logged in between page refreshes
                            //localStorage.setItem(OTC_USERSTATE, JSON.stringify(user));
                            setCurrentUser(user);

                            TF.PublishCommand('COMMAND.changeuser', data.result);
                            dispatch({ type: 'LOGIN_SUCCESS', payload: { user: data.result } });
                        }
                        else {
                            dispatch({ type: 'LOGIN_FAILED', payload: { error: "Ошибка. Процесс авторизации не завершен. Повторите попытку входа" } });
                        }
                        history.pushState({}, '', loginInput.returnUrl || '/');
                    }
                    else {
                        dispatch({ type: 'LOGIN_FAILED', payload: { error: "Ошибка. Данные пользователя не актуальны. Повторите попытку входа" } });
                    }

                    //dispatch(push(loginInput.returnUrl || '/'));
                } else {
                    let _error: string | any[] | undefined;

                    let data: DTO.ErrorMessageDto<Credentials> | undefined = undefined;
                    try {
                        data = await response.json() as DTO.ErrorMessageDto<Credentials>;

                        console.log('ErrorMessageDto');
                        console.log(data);
                    } catch (e) { data = undefined; }

                    if (statusCode == 401) {
                        _error = "Неверный логин или пароль";
                        if (data && data.validation)
                            _error = data.validation;
                    }
                    else {
                        //const data = await response.json() as DTO.ErrorMessageDto<Credentials>;
                        if (data) {
                            if (data.value && data.value.islockedout)
                                _error = "Аккаунт заблокирован. Обратитесь к администратору";
                            else {
                                if (Array.isArray(data.validation))
                                    _error = data.validation[0].messages[0].text;
                                else
                                    _error = data.validation;
                            }
                        }


                        //console.log(_error);
                    }

                    dispatch({ type: 'LOGIN_FAILED', payload: { error: _error || "Ошибка входа" } });
                }
            }
            catch (e) {
                dispatch({ type: 'LOGIN_FAILED', payload: { error: e.message || "Ошибка входа" } });
            }
        })();
    },
    changepass: (pmod: PassModification, getState: any, dispatch: (action: LoginAction) => {}) => {

        return (async () => {
            dispatch({ type: 'START_CHPASS' });

            try {
                const xsrf = getState().xsrfToken ? getState().xsrfToken : '';
                //console.log('post=' + JSON.stringify(loginInput));
                const response: Response = await fetch(API.apiUrl(API.API_CHANGEPASS_URL), {
                    method: 'POST',
                    credentials: 'include',
                    headers: new Headers({
                        ...
                        { 'Content-Type': 'application/json', 'X-XSRF-TOKEN': xsrf },
                        ...API.authHeader()
                    }),
                    body: JSON.stringify(pmod)
                });

                const statusCode = response.status;
                //console.log('statusCode = ' + statusCode);

                if (response.ok) {
                    const resp_data = await response.json();
                    //console.log(resp_data);
                    const data = resp_data as DTO.MessageDto<UserState>;

                    if (data && data.result) {
                        let user = data.result;
                        if (user && user.identityState.authTokenState && user.identityState.authTokenState.token) {
                            // store user details and jwt token in local storage to keep user logged in between page refreshes
                            //localStorage.setItem(OTC_USERSTATE, JSON.stringify(user));
                            setCurrentUser(user);

                            TF.PublishCommand('COMMAND.changeuser', data.result);
                            dispatch({ type: 'CHPASS_SUCCESS', payload: { user: data.result } });
                        }
                        else {
                            dispatch({ type: 'CHPASS_FAILED', payload: { error: "Ошибка. Процесс смены пароля не завершен. Повторите попытку" } });
                        }
                        history.pushState({}, '', pmod.returnUrl || '/');
                    }
                    else {
                        dispatch({ type: 'CHPASS_FAILED', payload: { error: "Ошибка. Данные пользователя не актуальны. Повторите попытку" } });
                    }

                    //dispatch(push(loginInput.returnUrl || '/'));
                } else {
                    var cmd_hdr = response.headers.get(API._API_CMD_HEADER);

                    if (cmd_hdr) {
                        TF.PublishSysCommand(cmd_hdr);
                    }

                    let _error: string | any[] | undefined;
                    if (statusCode == 401) {
                        _error = "Неверный логин или пароль";
                    }
                    else {
                        const data = await response.json() as DTO.ErrorMessageDto<PassModification>;
                        _error = data.validation;
                    }

                    //console.log(_error);

                    dispatch({ type: 'CHPASS_FAILED', payload: { error: _error || "Ошибка смены пароля" } });
                }
            }
            catch (e) {
                dispatch({ type: 'CHPASS_FAILED', payload: { error: e.message || "Ошибка смены пароля" } });
            }
        })();
    },
    logout: (getState: any, dispatch: (action: LoginAction) => {}) => {
        return (async () => {
            dispatch({ type: 'START_LOGOUT' });

            try {

                //var xsrf = getState().xsrf.token;
                const xsrf = getState().xsrfToken;
                //var hdr = { ...{ 'X-XSRF-TOKEN': xsrf }, ...API.authHeader() };
                //console.log('hdr');
                //console.log(hdr);
                const response: Response = await fetch(API.apiUrl(API.API_LOGOUT_URL), {
                    method: 'POST',
                    credentials: 'include',
                    headers: new Headers({
                        ...
                        { 'X-XSRF-TOKEN': xsrf },
                        ...API.authHeader()
                    }
                    )
                });

                const statusCode = response.status;

                if (response.ok) {
                    // Get updated xsrf token
                    //dispatch(XsrfActionCreators.refresh());
                    // Get updated menu; we may get extra options based on our role
                    // dispatch(NavMenuActionCreators.fetchMenu());
                    // dispatch(push('/'));

                    //localStorage.removeItem(OTC_USERSTATE);
                    logoffUser();

                    TF.PublishCommand('COMMAND.changeuser', {});
                    dispatch({ type: 'LOGOUT_SUCCESS' });

                    //dispatch(push('/'));

                } else {
                    if (statusCode == 401) {
                        //localStorage.removeItem(OTC_USERSTATE);
                        logoffUser();
                        TF.PublishCommand('COMMAND.changeuser', {});
                    }

                    dispatch({ type: 'LOGOUT_FAILED' });
                }
            }
            catch (e) {
                dispatch({ type: 'LOGOUT_FAILED' });
            }

        })();
    }
};





//import { authHeader, config } from '../_helpers';

//export const userService = {
//    login,
//    logout,
//    register,
//    getAll,
//    getById,
//    update,
//    delete: _delete
//};

//function login(username, password) {
//    const requestOptions = {
//        method: 'POST',
//        headers: { 'Content-Type': 'application/json' },
//        body: JSON.stringify({ username, password })
//    };

//    return fetch(config.apiUrl + '/users/authenticate', requestOptions)
//        .then(handleResponse, handleError)
//        .then(user => {
//            // login successful if there's a jwt token in the response
//            if (user && user.token) {
//                // store user details and jwt token in local storage to keep user logged in between page refreshes
//                localStorage.setItem('user', JSON.stringify(user));
//            }

//            return user;
//        });
//}

//function logout() {
//    // remove user from local storage to log user out
//    localStorage.removeItem('user');
//}

//function getAll() {
//    const requestOptions = {
//        method: 'GET',
//        headers: authHeader()
//    };

//    return fetch(config.apiUrl + '/users', requestOptions).then(handleResponse, handleError);
//}

//function getById(id) {
//    const requestOptions = {
//        method: 'GET',
//        headers: authHeader()
//    };

//    return fetch(config.apiUrl + '/users/' + _id, requestOptions).then(handleResponse, handleError);
//}

//function register(user) {
//    const requestOptions = {
//        method: 'POST',
//        headers: { 'Content-Type': 'application/json' },
//        body: JSON.stringify(user)
//    };

//    return fetch(config.apiUrl + '/users/register', requestOptions).then(handleResponse, handleError);
//}

//function update(user) {
//    const requestOptions = {
//        method: 'PUT',
//        headers: { ...authHeader(), 'Content-Type': 'application/json' },
//        body: JSON.stringify(user)
//    };

//    return fetch(config.apiUrl + '/users/' + user.id, requestOptions).then(handleResponse, handleError);
//}

//// prefixed function name with underscore because delete is a reserved word in javascript
//function _delete(id) {
//    const requestOptions = {
//        method: 'DELETE',
//        headers: authHeader()
//    };

//    return fetch(config.apiUrl + '/users/' + id, requestOptions).then(handleResponse, handleError);
//}

//function handleResponse(response) {
//    return new Promise((resolve, reject) => {
//        if (response.ok) {
//            // return json if it was returned in the response
//            var contentType = response.headers.get("content-type");
//            if (contentType && contentType.includes("application/json")) {
//                response.json().then(json => resolve(json));
//            } else {
//                resolve();
//            }
//        } else {
//            // return error message from response body
//            response.text().then(text => reject(text));
//        }
//    });
//}

//function handleError(error) {
//    return Promise.reject(error && error.message);
//}